/**
 * Page Show Description Formatter.
 * Toggles the `show_description` boolean on a Page record.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.pageShowDescriptionFormatter = function(value, row) {
    let domainId = $('#domain_id').val();
    let url = '/domains/show/pages/toggle/' + domainId + '/' + row.id;

    return toggleableFormatter(value, row, 'show_description', url);
};
